import React, { useState, useEffect, useCallback } from "react";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { Approve } from "./Approve";
import { History } from "./History";
import { Approved } from "./Reject";
import BSDateRangePicker from "pages/MyZone/Status/DateRangePicker";
import * as Mui from "@mui/material";
import moment from "moment";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import { showToast } from "services/utils/Status";
import { useSelector, useDispatch } from "react-redux";
import { themes, defaultAllSelection } from "services/constants";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import sessionHandling from "services/utils/notificationUtils";

const overTimeKeyPair = [
  {
    key: "checkbox",
    name: "",
  },
  {
    key: "user_name",
    name: "Employee name",
  },
  {
    key: "date",
    name: "Date",
  },

  {
    key: "shift_name",
    name: "Shift Name",
  },
  {
    name: "Approval Type",
    key: "approval_type",
  },

  {
    key: "check_in_datetime",
    name: "Check-in",
  },
  {
    key: "check_out_datetime",
    name: "Check-out",
  },
  {
    key: "action",
    name: "Action",
  },
];

export const WeekOff = () => {
  const dispatch = useDispatch();
  const { domain, token, userDetails, globalSearchValue, topbarCompanyId } =
    useSelector((state) => state.tokenReducer);

  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );

  const [overTimeScreen, setOverTimeScreen] = useState("Approve");
  const [selectComponent, setSelectComponent] = useState("Approve");
  const [departmentData, setDepartmentData] = useState([]);
  const [initialRun, setInitialRun] = useState(true);
  const [pendingDetails, setPendingDetails] = useState([]);
  const [listViewPage, setListViewPage] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [searchStartDate, setSearchStartDate] = useState("");
  const [searchEndDate, setSearchEndDate] = useState("");
  const [overTimeDetails, setOverTimeDetails] = useState([]);
  const [loader, setLoader] = useState(false);

  const handleStartDateAndEnd = useCallback(
    async (startDate, endDate) => {
      setSearchStartDate(startDate.split("/").reverse().join("-"));
      setSearchEndDate(endDate.split("/").reverse().join("-"));
      setLoader(true);
      try {
        const response = await fetch(
          `${domain}week-off-approvals/?user_id=${userDetails.id}&department_id=99999&status=Pending&company_id=${topbarCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const combinedData = res.map((item) => ({
            ...item,
            overtime_period: `${item.check_in || "N/A"} to ${
              item.check_out || "N/A"
            }`,
          }));
          setOverTimeDetails(combinedData);
          setPendingDetails(combinedData);
          setLoader(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        console.log(error);
      }
    },
    [domain, token, topbarCompanyId, userDetails.id]
  );

  useEffect(() => {
    if (initialRun) {
      dispatch(setDepartmentName("All"));
      dispatch(setDepartmentId(99999));
      const currentDate = new Date();
      const currentDay = currentDate.getDay();
      const diffToMonday = currentDay === 0 ? -6 : 1 - currentDay;
      const mostRecentMonday = new Date(
        currentDate.setDate(currentDate.getDate() + diffToMonday)
      );
      const currentDateDetails = new Date();
      const diffToSunday = currentDay === 0 ? 0 : 7 - currentDay;
      const currentWeekSunday = new Date(
        currentDateDetails.setDate(currentDateDetails.getDate() + diffToSunday)
      );
      handleStartDateAndEnd(
        moment(new Date(mostRecentMonday.toISOString().split("T")[0])).format(
          "DD/MM/YYYY"
        ),
        moment(new Date(currentWeekSunday.toISOString().split("T")[0])).format(
          "DD/MM/YYYY"
        )
      );
      setInitialRun(false);
    }
  }, [dispatch, handleStartDateAndEnd, initialRun]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      setLoader(true);
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const allDepartment = {
            id: defaultAllSelection,
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...res]);
          setLoader(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);

  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setOverTimeScreen(newAlignment);
    }
  };
  const renderComponent = () => {
    switch (selectComponent) {
      case "Approve":
        return (
          <Approve
            overTimeDetails={overTimeDetails}
            listViewPage={listViewPage}
            setListViewPage={setListViewPage}
            refreshReCall={refreshReCall}
            overTimeKeyPair={overTimeKeyPair}
            setSelectAll={setSelectAll}
            selectAll={selectAll}
            loader={loader}
            pendingDetails={pendingDetails}
          />
        );
      case "History":
        return <History startDate={searchStartDate} endDate={searchEndDate} />;
      case "Reject":
        return <Approved startDate={searchStartDate} endDate={searchEndDate} />;
      default:
        break;
    }
  };
  const updateDepartmentName = (event, data) => {
    if (data) {
      dispatch(setDepartmentId(data.id));
      dispatch(setDepartmentName(data.label));
      localStorage.setItem("approveLeaveDepartmentId", data.id);
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      if (overTimeScreen === "Approve") {
        handleStartDate(
          searchStartDate.split("-").reverse().join("/"),
          searchEndDate.split("-").reverse().join("/"),
          data.id
        );
      }
      setSelectAll(false);
    }
  };

  const handleStartDate = async (startDate, endDate, id) => {
    if (overTimeScreen === "Approve") {
      setSearchStartDate(startDate.split("/").reverse().join("-"));
      setSearchEndDate(endDate.split("/").reverse().join("-"));
      setLoader(true);
      try {
        const response = await fetch(
          `${domain}week-off-approvals/?user_id=${
            userDetails.id
          }&department_id=${
            id ? id : departmentId
          }&status=Pending&company_id=${topbarCompanyId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const combinedData = res.map((item) => ({
            ...item,
            overtime_period: `${item.check_in || "N/A"} to ${
              item.check_out || "N/A"
            }`,
          }));
          setOverTimeDetails(combinedData);
          setPendingDetails(combinedData);
          setSelectAll(false);
          setLoader(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.message);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    } else {
      setSearchStartDate(startDate.split("/").reverse().join("-"));
      setSearchEndDate(endDate.split("/").reverse().join("-"));
    }
  };

  const refreshReCall = useCallback(async () => {
    setLoader(true);
    try {
      const response = await fetch(
        `${domain}week-off-approvals/?user_id=${userDetails.id}&department_id=${departmentId}&status=Pending&company_id=${topbarCompanyId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        }
      );
      const res = await response.json();
      if (response.ok) {
        const combinedData = res.map((item) => ({
          ...item,
          overtime_period: `${item.check_in || "N/A"} to ${
            item.check_out || "N/A"
          }`,
        }));
        setOverTimeDetails(combinedData);
        setPendingDetails(combinedData);
        setSelectAll(false);
        setLoader(false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        throw new Error(res.error);
      }
    } catch (error) {
      showToast("error", error.message);
    }
  }, [departmentId, domain, token, topbarCompanyId, userDetails.id]);

  useEffect(() => {
    if (topbarCompanyId) {
      refreshReCall();
    }
  }, [refreshReCall, topbarCompanyId]);

  useEffect(() => {
    const searchFields = [
      "user_name",
      "date",
      "shift",
      "check_in_datetime",
      "check_out_datetime",
    ];
    const filteredResults = pendingDetails.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setOverTimeDetails(filteredResults);
    setListViewPage(globalSearchValue ? 0 : listViewPage);
  }, [globalSearchValue, listViewPage, pendingDetails]);

  return (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 5, paddingLeft: 3 }}>
        <Mui.Grid xs={5}>
          <Mui.Box
            sx={{
              display: "flex",
              alignItems: "center",
              width: 500,
              height: 55,
              position: "relative",
              overflow: "hidden",
            }}
          >
            <Mui.ToggleButtonGroup
              value={overTimeScreen}
              exclusive
              onChange={handleChange}
              sx={{
                display: "flex",
                width: "100%",
                height: "100%",
                position: "absolute",
                borderRadius: "30px",
                backgroundColor: themes.lightBrown,
              }}
            >
              <Mui.ToggleButton
                value="Approve"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  borderRadius: "30px",
                  fontWeight: 600,
                  border: "none",
                  color:
                    overTimeScreen === "Approve"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    overTimeScreen === "Approve"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      overTimeScreen === "Approve"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "Approve"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  handleStartDate(
                    searchStartDate.split("-").reverse().join("/"),
                    searchEndDate.split("-").reverse().join("/"),
                    departmentId,
                    refreshReCall(),
                    dispatch(setGlobalSearchValue("")),
                    setSelectComponent("Approve")
                  );
                }}
              >
                Approve
              </Mui.ToggleButton>
              <Mui.ToggleButton
                value="History"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  fontWeight: 600,
                  border: "none",
                  color:
                    overTimeScreen === "History"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    overTimeScreen === "History"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      overTimeScreen === "History"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "History"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  dispatch(setGlobalSearchValue(""));
                  setSelectComponent("History");
                }}
              >
                History
              </Mui.ToggleButton>
              <Mui.ToggleButton
                value="Reject"
                sx={{
                  flex: 1,
                  textTransform: "capitalize",
                  fontSize: 18,
                  borderRadius: "30px",
                  fontWeight: 600,
                  border: "none",
                  color:
                    overTimeScreen === "Reject"
                      ? themes.whiteColor
                      : themes.headLine,
                  backgroundColor:
                    overTimeScreen === "Reject"
                      ? themes.headLine
                      : themes.lightBrown,
                  "&.Mui-selected": {
                    backgroundColor: themes.headLine,
                    color: themes.whiteColor,
                    "&:hover": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                    },
                    borderRadius: "30px",
                    "&.Mui-selected": {
                      borderRadius: "30px",
                    },
                  },
                  "&:hover": {
                    backgroundColor:
                      overTimeScreen === "Reject"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "Reject"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                  "&:focus": {
                    backgroundColor:
                      overTimeScreen === "Reject"
                        ? themes.headLine
                        : themes.lightBrown,
                    color:
                      overTimeScreen === "Reject"
                        ? themes.whiteColor
                        : themes.headLine,
                  },
                }}
                onClick={() => {
                  dispatch(setGlobalSearchValue(""));
                  setSelectComponent("Reject");
                }}
              >
                Rejected
              </Mui.ToggleButton>
            </Mui.ToggleButtonGroup>
          </Mui.Box>
        </Mui.Grid>

        <>
          {selectComponent === "Approve" ? (
            <Mui.Grid xs={4.45}></Mui.Grid>
          ) : (
            <Mui.Grid xs={1.9}></Mui.Grid>
          )}
          {selectComponent !== "Apply" ? (
            <Mui.Grid xs={2.4}>
              <CustomAutoComplete
                dataList={departmentData?.map((obj) => ({
                  ...obj,
                  label: obj.department_name,
                }))}
                selectedValue={departmentName}
                updateDataFunction={updateDepartmentName}
                placeHolder="Select department name"
                label="Select Department Name"
              />
            </Mui.Grid>
          ) : null}
          <Mui.Grid xs={0.1}></Mui.Grid>
          {selectComponent !== "Approve" && selectComponent !== "Apply" ? (
            <Mui.Grid xs={2.4}>
              <BSDateRangePicker
                handleStartDate={handleStartDate}
                showToday={true}
                triggerDate={true}
              />
            </Mui.Grid>
          ) : null}
        </>
        <Mui.Grid container>{renderComponent()}</Mui.Grid>
      </Mui.Grid>
    </React.Fragment>
  );
};
